import React from "react";
import PropTypes from "prop-types";

import { commonPropTypes } from "./entities-selector";
import SelectComponent from "./SelectComponent";
import { useCurrentCustomerContext } from "../current-customer-context";

const CustomerSelect = ({ multiple, name, label, id, handleChange, value }) => {
  const { customers } = useCurrentCustomerContext();

  return (
    <SelectComponent
      name={name}
      multiple={multiple}
      label={label}
      id={id}
      value={value}
      handleChange={handleChange}
      elements={customers}
      getValueFromElement={item => item._id}
      getLabelFromElement={item => item.description}
      itemKey="_id"
      itemValue="_id"
      itemLabel="description"
    />
  );
};

CustomerSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del texto de la opción vacía, si existe (opcional)
   */
  emptyValueText: PropTypes.string,
};

export default CustomerSelect;
